import { Chip } from '@otp/ui';
import { UserLevel } from 'src/graphql/generated/graphql';

const LEVEL_MAP: Record<UserLevel, string> = {
  [UserLevel.Otp0]: 'OTP0',
  [UserLevel.Otp1]: 'OTP1',
  [UserLevel.Otp2]: 'OTP2',
  [UserLevel.Otp3]: 'OTP3',
  [UserLevel.Otp4]: 'OTP4',
  [UserLevel.Rep0]: 'Rep0',
  [UserLevel.Rep1]: 'Rep1',
  [UserLevel.Stp0]: 'STP0',
  [UserLevel.Stp1]: 'STP1',
  [UserLevel.Stp2]: 'STP2',
  [UserLevel.Stp3]: 'STP3',
  [UserLevel.Partner0]: 'Partner0',
  [UserLevel.Partner1]: 'Partner1',
  [UserLevel.Partner2]: 'Partner2',
  [UserLevel.Partner3]: 'Partner3',
};

export const UserLevelColumn = ({ level }: { level?: UserLevel }) => {
  if (!level) {
    return null;
  }

  return <Chip label={LEVEL_MAP[level]} color="primary" />;
};
